﻿{
  "US": "Estados Unidos",
  "AF": "Afeganistão",
  "AX": "Ilhas de Aland",
  "AL": "Albânia",
  "DZ": "Argélia",
  "AS": "Samoa Americana",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antártida",
  "AG": "Antígua e Barbuda",
  "AR": "Argentina",
  "AM": "Armênia",
  "AW": "Aruba",
  "AU": "Austrália",
  "AT": "Áustria",
  "AZ": "Azerbaijão",
  "BS": "Bahamas",
  "BH": "Barein",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Bélgica",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermudas",
  "BT": "Butão",
  "BO": "Bolívia",
  "BA": "Bósnia e Herzegovina",
  "BW": "Botsuana",
  "BV": "Ilha Bouvet",
  "BR": "Brasil",
  "IO": "Território Britânico do Oceano Índico",
  "BN": "Brunei Darussalam",
  "BG": "Bulgária",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Camboja",
  "CM": "Camarões",
  "CA": "Canadá",
  "CV": "Cabo Verde",
  "KY": "Ilhas Cayman",
  "CF": "República Centro Africana",
  "TD": "Chade",
  "CL": "Chile",
  "CN": "China",
  "CX": "Ilha de Natal",
  "CC": "Ilhas Cocos (Keeling)",
  "CO": "Colômbia",
  "KM": "Comores",
  "CG": "Congo",
  "CD": "Congo, República Democrática",
  "CK": "Ilhas Cook",
  "CR": "Costa Rica",
  "CI": "Costa do Marfim",
  "HR": "Croácia",
  "CU": "Cuba",
  "CY": "Chipre",
  "CZ": "República Tcheca",
  "DK": "Dinamarca",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "República Dominicana",
  "EC": "Equador",
  "EG": "Egito",
  "SV": "El Salvador",
  "GQ": "Guiné-Equatorial",
  "ER": "Eritréia",
  "EE": "Estônia",
  "ET": "Etiópia",
  "FK": "Ilhas Falkland (Malvinas)",
  "FO": "Ilhas Faroé",
  "FJ": "Fiji",
  "FI": "Finlândia",
  "FR": "França",
  "GF": "Guiana Francesa",
  "PF": "Polinésia Francesa",
  "TF": "Terras Austrais e Antárticas Francesas",
  "GA": "Gabão",
  "GM": "Gâmbia",
  "GE": "Geórgia",
  "DE": "Alemanha",
  "GH": "Gana",
  "GI": "Gibraltar",
  "GR": "Grécia",
  "GL": "Groenlândia",
  "GD": "Granada",
  "GP": "Guadalupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guiné",
  "GW": "Guiné-Bissau",
  "GY": "Guiana",
  "HT": "Haiti",
  "HM": "Ilhas Heard e Ilhas McDonald",
  "VA": "Santa Sé (Estado da Cidade do Vaticano)",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungria",
  "IS": "Islândia",
  "IN": "Índia",
  "ID": "Indonésia",
  "IR": "Irã, República Islâmica do",
  "IQ": "Iraque",
  "IE": "Irlanda",
  "IM": "Ilha de Man",
  "IL": "Israel",
  "IT": "Itália",
  "JM": "Jamaica",
  "JP": "Japão",
  "JE": "Jersey",
  "JO": "Jordânia",
  "KZ": "Cazaquistão",
  "KE": "Quênia",
  "KI": "Kiribati",
  "KR": "Coreia",
  "KW": "Kuwait",
  "KG": "Quirguistão",
  "LA": "Laos, República Democrática Popular",
  "LV": "Letônia",
  "LB": "Líbano",
  "LS": "Lesoto",
  "LR": "Libéria",
  "LY": "Líbia",
  "LI": "Liechtenstein",
  "LT": "Lituânia",
  "LU": "Luxemburgo",
  "MO": "Macau",
  "MK": "Macedônia",
  "MG": "Madagascar",
  "MW": "Malaui",
  "MY": "Malásia",
  "MV": "Maldivas",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Ilhas Marshall",
  "MQ": "Martinica",
  "MR": "Mauritânia",
  "MU": "Ilhas Maurício",
  "YT": "Mayotte",
  "MX": "México",
  "FM": "Micronésia, Estados Federados da",
  "MD": "Moldávia",
  "MC": "Mônaco",
  "MN": "Mongólia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Marrocos",
  "MZ": "Moçambique",
  "MM": "Myanmar",
  "NA": "Namíbia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Holanda",
  "AN": "Antilhas Holandesas",
  "NC": "Nova Caledônia",
  "NZ": "Nova Zelândia",
  "NI": "Nicarágua",
  "NE": "Níger",
  "NG": "Nigéria",
  "NU": "Niue",
  "NF": "Ilha Norfolk",
  "MP": "Ilhas Marianas do Norte",
  "NO": "Noruega",
  "OM": "Omã",
  "PK": "Paquistão",
  "PW": "Palau",
  "PS": "Estado da Palestina, Ocupado",
  "PA": "Panamá",
  "PG": "Papua Nova Guiné",
  "PY": "Paraguai",
  "PE": "Peru",
  "PH": "Filipinas",
  "PN": "Pitcairn",
  "PL": "Polônia",
  "PT": "Portugal",
  "PR": "Porto Rico",
  "QA": "Catar",
  "RE": "Ilha Reunião",
  "RO": "Romênia",
  "RU": "Federação da Rússia",
  "RW": "Ruanda",
  "BL": "São Bartolomeu",
  "SH": "Santa Helena",
  "KN": "São Cristóvão e Nevis",
  "LC": "Santa Lúcia",
  "MF": "São Martin",
  "PM": "São Pedro e Miquelão",
  "VC": "São Vicente e Granadinas",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "São Tomé e Príncipe",
  "SA": "Arábia Saudita",
  "SN": "Senegal",
  "RS": "Sérvia",
  "SC": "Seychelles",
  "SL": "Serra Leoa",
  "SG": "Singapura",
  "SK": "Eslováquia",
  "SI": "Eslovênia",
  "SB": "Ilhas Salomão",
  "SO": "Somália",
  "ZA": "África do Sul",
  "GS": "Ilhas Geórgia do Sul e Sandwich",
  "ES": "Espanha",
  "LK": "Sri Lanka",
  "SD": "Sudão",
  "SR": "Suriname",
  "SJ": "Svalbard e Jan Mayen",
  "SZ": "Suazilândia",
  "SE": "Suécia",
  "CH": "Suíça",
  "SY": "Síria, República Árabe da",
  "TW": "Taiwan",
  "TJ": "Tadjiquistão",
  "TZ": "Tanzânia",
  "TH": "Tailândia",
  "TL": "Timor Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidade e Tobago",
  "TN": "Tunísia",
  "TR": "Turquia",
  "TM": "Turcomenistão",
  "TC": "Ilhas Turks e Caicos",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ucrânia",
  "AE": "Emirados Árabes Unidos",
  "GB": "Reino Unido",
  "UM": "Ilhas Distantes dos Estados Unidos",
  "UY": "Uruguai",
  "UZ": "Uzbequistão",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnã",
  "VG": "Ilhas Virgens Britânicas",
  "VI": "Ilhas Virgens Americanas",
  "WF": "Wallis e Futuna",
  "EH": "Saara Ocidental",
  "YE": "Iêmen",
  "ZM": "Zâmbia",
  "ZW": "Zimbábue"
}
